module.exports = __webpack_public_path__ + "static/media/archangel-michael.037861db.jpg";